import moment from "moment";

export default function getTimeNow() {
  return moment();
}
